import React from 'react';
import styled from 'styled-components';
import {Button, Modal, Table, Input, message} from 'antd';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import {useOutlet, getOutlet, getNewOutlet} from 'reconnect.js';
import * as AppActions from '../../AppActions';
import {ModalCustomStyle} from '../../AppContext/customStyledCss';

getNewOutlet('admin-search-int-exc-modal', null, {autoDelete: false});

export function showAdminSearchIntExcModal(data) {
  console.log('DBG data', data);
  getOutlet('admin-search-int-exc-modal').update(data);
}

const fetchRecords = async (
  keyword,
  columns,
  paging = {offset: 0, limit: 4},
) => {
  try {
    AppActions.setLoading(true);
    return JStorage.fetchDocuments(
      'international_exchange',
      {
        $or: columns.map((column) => ({
          [column.key]: {$regex: keyword},
        })),
      },
      null,
      paging,
    );
  } catch (err) {
    message.error('發生錯誤。');
  } finally {
    AppActions.setLoading(false);
  }
};

export default function AdminSearchIntExtModal(props) {
  const [data, setData] = useOutlet('admin-search-int-exc-modal');
  const [keyword, setKeyword] = React.useState(null);
  const [records, setRecords] = React.useState(null);
  // const [_selectedRows, _setSelectedRows] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    total: 0,
    pageSize: 4,
  });

  const columns = [
    {key: 'title', title: '名稱', dataIndex: 'title'},
    {key: 'country', title: '國家/地區', dataIndex: 'country'},
    {
      key: 'exchange_unit',
      title: '交流單位',
      dataIndex: 'exchange_unit',
    },
    {
      key: '',
      title: '',
      dataIndex: '',
      render: (_, item) => {
        return (
          <Button
            onClick={() => {
              data.onChange(item.id);
              onClose();
            }}>
            選擇
          </Button>
        );
      },
    },
  ];

  function onClose() {
    setKeyword(null);
    setRecords(null);
    // _setSelectedRows([]);
    setData(null);
  }

  return (
    <Modal
      visible={!!data}
      onCancel={onClose}
      footer={null}
      width={1000}
      closable={false}
      maskClosable={true}
      destroyOnClose={true}>
      <Wrapper>
        <Input.Search
          style={{marginBottom: 10}}
          placeholder="請輸入關鍵字"
          allowClear
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onSearch={async () => {
            let {total, results} = await fetchRecords(keyword, columns, {
              offset: 0,
              limit: pagination.pageSize,
            });
            setRecords(results);
            setPagination({...pagination, total});
          }}
        />

        <Table
          style={{marginBottom: 10}}
          scroll={{x: 500, y: 300}}
          pagination={{
            ...pagination,
            onChange: async (page, pageSize) => {
              let {total, results} = await fetchRecords(keyword, columns, {
                offset: (page - 1) * pageSize,
                limit: pageSize,
              });
              setRecords(results);
              setPagination({...pagination, total});
            },
          }}
          /*
          rowKey={(record) => record.owner}
          rowSelection={{
            type: 'radio',
            onChange: (selectedRowKeys, selectedRows) => {
              _setSelectedRows(selectedRows);
            },
          }}
          */
          columns={columns}
          dataSource={records}
        />
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled(ModalCustomStyle)``;
